import React from 'react'
import slug from "slug";

export default props => {
  const id = slug(props.children);
  return <h3 id={id} {...props}>
    <a href={`#${id}`}>{props.children}</a>
    </h3>
}
